import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store';
import modalSlickAlt from 'src/images/modalSlickAlt.png';
import { changeEnterHTML } from 'src/utils/changeEnter';
import { trackingList } from 'src/utils/valueHTML';
import { getFontURL } from 'src/utils/getFontUrl';

const CarouselSlideModalHTML: FC = () => {
  const bg = useSelector((state: RootState) => state.imageUpload.bg);
  const bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  const bgOpacity = useSelector(
    (state: RootState) => state.imageUpload.bgImageBlur
  );
  const bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);
  const radius = useSelector((state: RootState) => state.imageUpload.radius);
  const deeplink = useSelector(
    (state: RootState) => state.imageUpload.deeplink
  );
  const text = useSelector((state: RootState) => state.editText.text);
  const fontSize = useSelector((state: RootState) => state.editText.fontSize);
  const fontWeight = useSelector(
    (state: RootState) => state.editText.fontWeight
  );
  const color = useSelector((state: RootState) => state.editText.color);
  const fontFamily = useSelector(
    (state: RootState) => state.editText.fontFamily
  );
  const textAlign = useSelector((state: RootState) => state.editText.textAlign);

  const btnText = useSelector((state: RootState) => state.buttons.btnText);
  const btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  const btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  const btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  const btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  const btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  const btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  const btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  const btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );

  const btnAgain = useSelector((state: RootState) => state.buttons.btnAgain);

  const tracking = useSelector((state: RootState) => state.trackings.tracking);
  const button1 = useSelector((state: RootState) => state.trackings.button1);
  const button2 = useSelector((state: RootState) => state.trackings.button2);

  const backgroundDimmed = bgOpacity?.bgDimmed / 100;
  const displayValue = backgroundDimmed >= 0.01 ? backgroundDimmed : 0.7;

  const multiTitleFontURL = getFontURL(fontFamily?.multi_title);
  const multiSubTitleFontURL = getFontURL(fontFamily?.multi_sub_title);
  const multiButtonURL = getFontURL(btnFontFamily?.multi_button);
  const multiLeftButtonURL = getFontURL(btnFontFamily?.multi_left_button);
  const multiRightButtonURL = getFontURL(btnFontFamily?.multi_right_button);
  // const multiTitleFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.multi_title}`;
  // const multiSubTitleFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.multi_sub_title}`;
  // const multiButtonURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily?.multi_button}`;
  // const multiLeftButtonURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily?.multi_left_button}`;
  // const multiRightButtonURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily?.multi_right_button}`;

  const style = `
  @font-face {
    font-family: 'multiTitle';
    src: url(${multiTitleFontURL});
  }
  @font-face {
    font-family: 'multiSubTitle';
    src: url(${multiSubTitleFontURL});
  }
  @font-face {
    font-family: 'multiButton';
    src: url(${multiButtonURL});
  }
  @font-face {
    font-family: 'multiLeftButton';
    src: url(${multiLeftButtonURL});
  }
  @font-face {
    font-family: 'multiRightButton';
    src: url(${multiRightButtonURL});
  }

    /* reset */
    * {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      list-style: none;
      text-decoration: none;      
    }
    
    html,
    body {
      height: 100%;
      overflow: hidden;
      font-size: 16px;      
    }
    main {
      height: 100%;
      position: relative;
    }
    a {
      color: #000000;
      cursor: pointer;
    }
    button {
      background: none;
      border: none;
    }

    /* custom */
    .root {      
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
      position: relative;
      background: none;
    }
    .background {
      width: 100%;
      height: 100%;

      position: absolute;
      top: 0;
      background: rgba(0, 0, 0, ${displayValue});
    }
    .center {
      width: 310px;      
      position: absolute;
      overflow: hidden;
      top:50%;
      transform: translate(0%,-50%);
      display: flex;
      flex-direction: column;          
    }

    .modal_wrapper {            
        display: flex;
        flex-direction: column;      
        padding-top: 0.8rem;
        border-radius: ${radius?.background}px;
  
        ${
          bg === 'image'
            ? `background-image: url(${bgImage?.background})`
            : `background: ${bgColor?.background}`
        };
  
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
    }

    .slick_wrapper,
    .slick_wrapper .slick-slider,
    .slick_wrapper .slick-list {
      width: 100%;
      height: 100%;
      position: relative;      
    }
    
    .slick_wrapper .slick_image_wrapper {                   
      width: 16.875rem;
      max-height: 21.75rem;
      min-height: 11.25rem;
      outline: 0;
      overflow: hidden;
  }

    .slick_wrapper .slick-list {
      padding: 0 -0.3rem;            
    }

    .slick_wrapper .slick-track {
      display: flex;
      align-items: center;                  
    }

    .slick_wrapper .slick-slide {
      padding: 0 5px;      
    }
    
    .slick_wrapper .slick-track img {      
      object-fit: cover;
      object-position: top;
      border-radius: ${radius?.multi_image}px;     
    }
   
    .contents_wrapper,
    .contents_wrapper .slick-slider,
    .contents_wrapper .slick-list,
    .contents_wrapper .slick-track div,
    .contents_wrapper .slick-track img {
      background-color: transparent;
    }
    .contents_wrapper {
      width: 100%;
      padding: 0 1.25rem;
    }
    .contents_box {
      width: 100%;
      height: 100%;
      margin-top: 1.25rem;
    }
    .contents_box .title {
      width: 100%;           
      display: flex;
      align-items: center;
      margin-bottom: 7px;
    }
    .title .title_inner {
      width: 100%;
      text-align: ${textAlign?.multi_title};
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 1.4;
      color: ${color?.multi_title};
      font-size: ${fontSize?.multi_title}rem;
      font-weight: ${fontWeight?.multi_title};      
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.multi_title
        )
          ? fontFamily.multi_title
          : 'multiTitle'
      };
      
    }
    .contents_box .sub_title {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
    }
    .contents_box .sub_title_inner {
      width: 100%;
      text-overflow: ellipsis;
      overflow: hidden;
      line-height: 1.54;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;

      text-align: ${textAlign?.multi_sub_title};
      color: ${color?.multi_sub_title};
      font-size: ${fontSize?.multi_sub_title}rem;
      font-weight: ${fontWeight?.multi_sub_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.multi_sub_title
        )
          ? fontFamily.multi_sub_title
          : 'multiSubTitle'
      };      
    }
    
    .slick_page {
      position: absolute;
      bottom: 0.3rem;
      right: 26px;
      
      display: flex;      
      justify-content: space-between;
      align-items: center;      
      padding: 0.19rem 0.5rem;
      
      color: #ffffff;
      font-family: Roboto;
      font-size: 0.7rem;
      font-weight: 400;

      border-radius: 999px;
      background-color: rgba(0, 0, 0, 0.8);
      z-index: 1;
    }

    .btn_wrapper {
      width: 100%;
      margin: 1rem 0rem 1.25rem 0rem;
    }
    .btn_wrapper button {
      width: 100%;
      height: 3rem;
      outline: 0;
      border: 0;
      padding: 0 16px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      font-size: ${btnFontSize?.multi_button}rem;
      font-weight: ${btnFontWeight?.multi_button};
      color: ${btnColor?.multi_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.multi_button
        )
          ? btnFontFamily.multi_button
          : 'multiButton'
      };
      border-radius: ${radius?.multi_button}px;
      background-color:rgba(${btnBgColorR?.multi_button},${
    btnBgColorG?.multi_button
  }, ${btnBgColorB?.multi_button}, ${btnBgColorA?.multi_button});
    }
    .bottom_wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 11px;
    }
    
    .bottom_wrapper .style01 {
      width: 100%;
      display: flex;
      align-items: center;
      gap: 0.5rem;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: ${btnColor?.multi_left_button};      
      font-weight: ${btnFontWeight?.multi_left_button};
      font-size: ${btnFontSize?.multi_left_button}rem;
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.multi_left_button
        )
          ? btnFontFamily.multi_left_button
          : 'multiLeftButton'
      };
    }
    .bottom_wrapper .style02 {
      width: 100%;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      text-align: right;
      color: ${btnColor?.multi_right_button};      
      font-weight: ${btnFontWeight?.multi_right_button};
      font-size: ${btnFontSize?.multi_right_button}rem;
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.multi_right_button
        )
          ? btnFontFamily.multi_right_button
          : 'multiRightButton'
      };
    }
    /*
    @media screen and (min-width: 608px) and (max-width: 1024px) {
      .modal_wrapper {
        width: 50%;
        height: 36.75rem;
        padding: 2rem 0;
        margin: 0 25%;
      }

      .close_btn {
        right: 25%;
        top: 4rem;
      }

      .slick_wrapper,
      .slick_wrapper .slick-slider,
      .slick_wrapper .slick-list {
        height: 16rem;
        margin-bottom: 1rem;
      }
      .slick_wrapper .slick_image_wrapper {
        max-width: 16rem;
        min-width: 16rem;
        max-height: 16rem;
        min-height: 16rem;
        outline: 0;
      }
      .slick-dots {
        margin-bottom: 10px;
      }

      .contents_wrapper {
        width: 100%;
        height: 10.25rem;
        padding: 0 2rem;
      }
      .contents_box {
        height: 9rem;
      }
      .contents_box .title {
        height: 3.5rem;
        font-size: ${fontSize?.multi_title + 0.25}rem;
      }
      .contents_box .sub_title {
        height: 5rem;
        font-size: ${fontSize?.multi_sub_title + 0.25}rem;
      }

      .btn_wrapper {
        padding: 0 2rem;        
      }
      .btn_wrapper button {
        width: 100%;
        height: 4rem;
      }
    }
    */
  `;

  // let deeplink_list2 = `[`;
  // for (let i = 0; i < deeplink?.multi_image?.length; i++) {
  //   deeplink_list2 += `"${deeplink?.multi_image?.[i]}"`;
  //   if (i !== deeplink?.multi_image?.length - 1) deeplink_list2 += ',';
  // }
  // deeplink_list2 += ']';

  const deeplink_list = JSON.stringify(deeplink?.multi_image);

  const html = `
    <div class="root">
      <div class="background" onclick="appboyBridge.logClick('background'); appboyBridge.closeMessage();"></div>
      <div class="center">      
      <div class="modal_wrapper">
        <div class="slick_wrapper">              
          <div class="slick_slider">${bgImage?.multi_image
            ?.map(
              (data: any, idx: number) => `
                    <div>
                      <img
                        class="slick_image_wrapper"
                        src="${data && data !== '' ? data : modalSlickAlt}"
                        alt=""
                      />
                  
                    </div>
                  `
            )
            .join('')} 
         </div>
         ${
           bgImage?.multi_image?.length !== 1
             ? `
                <div class="slick_page">
                  <span class="slick_number"></span>
                  <span style="color:#828282; margin:0rem 0.2rem;">/</span>
                  <span style="color:#828282;">${bgImage?.multi_image?.length}</span>
                </div>
                `
             : ''
         }
        </div>
        <div class="contents_wrapper">
          <div class="contents_slider">${text?.multi_title
            ?.map(
              (data: any, idx: number) => `
            <div class="contents_box">
              <div class="title">
                <div class="title_inner">
                  ${changeEnterHTML(text?.multi_title?.[idx])}
                </div>
              </div>
              <div class="sub_title">
                <div class="sub_title_inner">                
                  ${changeEnterHTML(text?.multi_sub_title?.[idx])}
                </div>
              </div>
            </div>`
            )
            .join('')}
          </div>          
          <div class="btn_wrapper">
            <button class="button_text">
            
            </button>
          </div>
        </div>
      </div>
           <div class="bottom_wrapper">
            <button class="style01"></button>
            <div style="display: flex; justify-content: center; align-items: center">
              <button class="style02"></button>
              <span class="material-icons" style="font-size: ${btnFontSize?.multi_right_button +
                0.35}rem; padding-bottom: 0.1rem; color:${
    btnColor?.multi_right_button
  };">close</span>
            </div>
          </div>
    </div> 
    <div id="test" style="display:none;">
      ${deeplink_list}
    </div> 
  </div>  
  `;

  let button_list = '[';
  for (let i = 0; i < btnText?.multi_button?.length; i++) {
    button_list += `["${btnText?.multi_button?.[i]}", "${btnText?.multi_left_button?.[i]}", "${btnText?.multi_right_button?.[i]}"]`;
    if (i !== btnText?.multi_button?.length - 1) button_list += ',';
  }
  button_list += ']';

  let tracking_list = '[';
  for (let i = 0; i < tracking?.multi_image?.length; i++) {
    tracking_list += `["${tracking?.multi_image?.[i]}", "${tracking?.multi_button?.[i]}", "${tracking?.multi_left_button?.[i]}", "${tracking?.multi_right_button?.[i]}"],`;
  }
  tracking_list += ']';

  const tracking_button_list = trackingList(
    'CAROUSEL SLIDE MODAL',
    button1,
    button2
  );

  const js = `
  document.addEventListener("DOMContentLoaded", function(){
    $('.slick_slider').slick({
      arrows: false,
      dots: false,
  
      centerMode: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      speed: 300,
      touchThreshold: 300
    });

    $('.contents_slider').slick({
      arrows: false,
      dots: false,
      fade: true,
      speed: 300,
      swipe: false
    });
    
    let currentIndex = 0;
    let button = ${button_list};
    $('.button_text').text(button[currentIndex][0]);
    $('.style01').text(button[currentIndex][1]);
    $('.style02').text(button[currentIndex][2]);
    $('.slick_number').text(currentIndex+1);
    $('.slick_slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
      currentIndex = $('.slick_slider').slick('slickCurrentSlide');
      $('.contents_slider').slick('goTo', currentIndex);
      $('.slick_number').text(currentIndex+1);
      $('.button_text').text(button[currentIndex][0]);
      $('.style01').text(button[currentIndex][1]);
      $('.style02').text(button[currentIndex][2]);
    });
    $('.contents_slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
      currentIndex = $('.contents_slider').slick('slickCurrentSlide');
      $('.slick_slider').slick('goTo', currentIndex);
      $('.slick_number').text(currentIndex+1);
      $('.button_text').text(button[currentIndex][0]);
      $('.style01').text(button[currentIndex][1]);
      $('.style02').text(button[currentIndex][2]);
    });
    
    let content = $("#test").text();
    
		// 불필요한 줄바꿈과 탭 문자를 제거합니다.
		let link = content.replace(/\\n|\\t/g, "").trim();
		
		let deeplink = JSON.parse(link);

    let tracking = ${tracking_list};
    let button1 = ${tracking_button_list[0]};
    let button2 = ${tracking_button_list[1]};
    $('.slick_image_wrapper').click(function() {
      try {
        appboyBridge.logClick(tracking[currentIndex][0]);
        if (button1[0].indexOf(currentIndex) !== -1) {
          appboyBridge.logClick('0');
        }
        if (button2[0].indexOf(currentIndex) !== -1) {
          appboyBridge.logClick('1');
        }
      } catch (err) {}
      window.location = deeplink[currentIndex];
    });
    $('.btn_wrapper').click(function() {
      try {
        appboyBridge.logClick(tracking[currentIndex][1]);
        if (button1[1].indexOf(currentIndex) !== -1) {
          appboyBridge.logClick('0');
        }
        if (button2[1].indexOf(currentIndex) !== -1) {
          appboyBridge.logClick('1');
        }
      } catch (err) {}
      window.location = deeplink[currentIndex];
    });
    $('.style01').click(function() {
      try {
        if ("${btnAgain?.type}" === "attribute") {
          appboyBridge.getUser().setCustomUserAttribute("${btnAgain?.multi_left_button}", new Date());
        }
        if ("${btnAgain?.type}" === "event") {
          appboyBridge.logCustomEvent("${btnAgain?.multi_left_button}");
        }
      } catch (err) {}

      try {
        appboyBridge.logClick(tracking[currentIndex][2]);
        if (button1[2].indexOf(currentIndex) !== -1) {
          appboyBridge.logClick('0');
        }
        if (button2[2].indexOf(currentIndex) !== -1) {
          appboyBridge.logClick('1');
        }
      } catch (err) {}
      appboyBridge.closeMessage();
    });
    $('.style02').click(function() {
      try {
        appboyBridge.logClick(tracking[currentIndex][3]);
        if (button1[3].indexOf(currentIndex) !== -1) {
          appboyBridge.logClick('0');
        }
        if (button2[3].indexOf(currentIndex) !== -1) {
          appboyBridge.logClick('1');
        }
      } catch (err) {}
      appboyBridge.closeMessage();
    });
  });
  `;

  return (
    <>
      <head>
        <meta charSet="UTF-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />
        <meta
          httpEquiv="Cache-Control"
          content="no-cache, no-store, must-revalidate"
        />
        <meta httpEquiv="Expires" content="0" />
        <meta httpEquiv="Pragma" content="no-cache" />
        {/* slick */}
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css"
        />

        {/* google font */}
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Archivo:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          rel="stylesheet"
          as="style"
          href="https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/static/pretendard.min.css"
        />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/icon?family=Material+Icons"
        />
        <style dangerouslySetInnerHTML={{ __html: style }} />
        <script src="https://code.jquery.com/jquery-3.6.0.min.js" />
        <script src="https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js" />
      </head>
      <body dangerouslySetInnerHTML={{ __html: html }} />
      <script dangerouslySetInnerHTML={{ __html: js }} />
    </>
  );
};
export default CarouselSlideModalHTML;
